import { render, staticRenderFns } from "./AddModalVerDetalle.vue?vue&type=template&id=6da2741c&"
import script from "./AddModalVerDetalle.vue?vue&type=script&lang=ts&"
export * from "./AddModalVerDetalle.vue?vue&type=script&lang=ts&"
import style0 from "./AddModalVerDetalle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6da2741c', component.options)
    } else {
      api.reload('6da2741c', component.options)
    }
    module.hot.accept("./AddModalVerDetalle.vue?vue&type=template&id=6da2741c&", function () {
      api.rerender('6da2741c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/Add/AddModalVerDetalle.vue"
export default component.exports